import FilterButton from "../buttons/FilterButton";
import ResetButton from "../buttons/ResetButton";
import SearchButton from "../buttons/SearchButton";

function MobileMenu({handleReset}: {handleReset: () => void}){
    return (
        <div className='flex w-full bg-river-500 divide-x divide-solid divide-ocean-700' style={{height: 96}}>
            <div className="flex-1"><SearchButton showActive={true} /></div>
            <div className="flex-1"><FilterButton showActive={true} /></div>
            <div className="flex-1"><ResetButton handleReset={handleReset} /></div>
        </div>
    )
}

export default MobileMenu
